// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"496":"eb69e33c","767":"e823892d","768":"e5f1901f"}[chunkId] + ".chunk.css";
};